import { FC, useEffect } from "react";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { Col, Row, Spinner, Table } from "react-bootstrap";
import { Eye } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { useAppDispatch } from "../../app/hooks";
import { getExportedNotImportedOrders } from "../../app/services/orderService";
import { RootState } from "../../app/store";
import AdminSubmenu from "../../features/adminSubmenu";
import { Order } from "../../models/responses/order";
import { ClientType } from "../../models/enums/clientTypeEnum";

const ExportedOrders: FC = () => {
    moment.locale("sv");
    moment.updateLocale(moment.locale(), { invalidDate: "-" });
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const orders: Order[] = useSelector(
        (state: RootState) => state.order.exportedNotImportedOrders
    );
    const loadingOrders = useSelector(
        (state: RootState) => state.order.isWaitingExportedNotImportedOrdersGetResponse
    );

    useEffect(() => {
        dispatch(getExportedNotImportedOrders(instance, account));
    }, [account, dispatch, instance]);

    const openOrderHandler = (order: Order) => {
        navigate(`/orderStatus/${order.orderStatusId}/orders/view/${order.id}`);
    };


    return (
        <div>
            <AdminSubmenu />
            <h2 className="mb-3">Exporterade ordrar som inte importerats</h2>
            <Table responsive striped bordered hover>
                <thead>
                    <tr>
                        <th>Ordertyp</th>
                        <th>Reg.nr</th>
                        <th>Exportad</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order) => (
                        <tr key={order.id} role="button" onClick={() => openOrderHandler(order)}>
                            <td>
                                {order.clientType === ClientType.Standard
                                    ? "Skadeverkstad"
                                    : order.clientType === ClientType.Catalog
                                        ? "AD Butik"
                                        : "Fleet"}
                            </td>
                            <td>{order.registrationNumber}</td>
                            <td>{moment.utc(order.exportedAt).tz("Europe/Stockholm").format("yyyy-MM-DD HH:mm")}</td>
                            <td align="center"><Eye /></td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            {loadingOrders && (
                <Row className="mb-3">
                    <Col className="text-center">
                        <Spinner variant="primary" />
                    </Col>
                </Row>
            )}
            {!loadingOrders && orders.length === 0 && <p>Inga ordrar att visa.</p>}
        </div>
    );
};

export default ExportedOrders;
